import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from "ngx-spinner";

import { MatSnackBar } from '@angular/material/snack-bar';

import { FormBuilder, FormGroup } from '@angular/forms'; // Import FormGroup and FormBuilder
import { AuthService } from 'src/app/services/auth.service';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-booking-list',
  templateUrl: './booking-list.component.html',
  styleUrls: ['./booking-list.component.scss']
})
export class BookingListComponent {
  // Define FormGroup
  searchForm: FormGroup;

  bookingNo: string = "";
 bookingParams: any;

  participantBookingDetails: any;
  originalParticipantBookingDetails: any;
  allRescheduledBookings: any[] = [];
  allCancelledBookings: any[] = [];
  isCancelled: boolean = false;
  isRescheduled: boolean = false;
  errors: any;
  bookingUserDetails: any;
  user: any;
  participantRescheduledBookingDetails: any;
  participantCancelledBookingDetails: any;
  message: string | undefined;



  currentPage: number = 1;
  itemsPerPage: number = 6; // Number of doctors per page
  paginatedParticipantDetails: any[] = [];
  paginatedCancelledDetails: any[] = [];
  paginatedRescheduledDetails: any[] = [];
  totalPages: number = 9;



  length = 0;
  pageSize = 6;
  pageIndex = 0;
  pageSizeOptions = [6, 12, 24];

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  pageEvent: PageEvent | any;



  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      // this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      // this.updatePagination();
    }
  }


   // Updates pagination for displaying current page's doctors for all bookings
   updatePagination() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedParticipantDetails = this.participantBookingDetails.slice(startIndex, endIndex);
  }

   // Updates pagination for displaying current page's doctors for all cancelled bookings
  updateCancelPagination() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedCancelledDetails = this.allCancelledBookings.slice(startIndex, endIndex);
  }

   // Updates pagination for displaying current page's doctors for all rescheduled bookings
  updateReschedulePagination() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedRescheduledDetails = this.allRescheduledBookings.slice(startIndex, endIndex);
  }

  // Handles pagination events
  handlePageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.updatePagination();
  }

  handleCancelPageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.updateCancelPagination();
  }

  handleReschedulePageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.updateReschedulePagination();
  }




  constructor(private router: Router, private storage: StorageService, private spinner: NgxSpinnerService, 
    private formBuilder: FormBuilder, private snackBar: MatSnackBar, private apiService: ApiService,public authService: AuthService,) {
    this.searchForm = this.formBuilder.group({
      branches: [''], // Initialize form control names here
      specialities: [''],
      bookingNo: [''],
    });
  }

  // Function for getting doctors according to search params
  getBookingDetails(bookingId: any) {
    // showing spinner
    this.spinner.show();
    // Api call for getting Booking details according to booking no
    this.apiService.getBookingIdDetails(bookingId).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.participantBookingDetails = [response.data];
          // hiding spinner
          this.spinner.hide();
        } else {
          this.snackBar.open(response.message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.spinner.hide();
        this.snackBar.open(err.error.message, '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        this.errors = err.error.message;
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
      }
    });
  }

  // Api for listing doctors according to search params
  search() {
    if (!this.bookingNo.trim()) {
      this.message = 'Please enter a booking number to search';
      setTimeout(() => {
        this.message = '';
      }, 3000);
      return;
    }

    // Clear message if booking number is valid
    this.message = '';

    this.isCancelled = false;
    this.isRescheduled = false;
    this.bookingParams = {
      'searchTerm': this.bookingNo
    };
    this.getBookingDetails(this.bookingParams)

  }

  getUserBookingDetails(bookingNO: string) {
    this.apiService.getBookingDetails(bookingNO).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.participantBookingDetails = response.data;  
          this.length = this.participantBookingDetails.length; 
          this.updatePagination();
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // this.storage.remove('token');
          this.spinner.hide();
        }
      },
      error: (err: any) => {
        this.snackBar.open(err.error.response.message, '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        // this.storage.remove('token');
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
       }
    });
  }

  applicantBookingDetails(bookingNo: string) {
    this.router.navigate(['/booking-list/booking-details', bookingNo]);
  }

  allBookings() {
    this.spinner.show();
    this.isCancelled = false;
    this.isRescheduled = false;
    this.errors = "";   
    this.bookingNo = "";
    this.getUserBookingDetails(this.user.data.phone);
    this.pageIndex = 0;
  }

  rescheduledBookings() {
    this.spinner.show();
    this.isRescheduled = true;
    this.isCancelled = false;
    this.errors = "";
    this.bookingNo = "";
    // Filter the bookings to get only the ones where booking_completely_rescheduled is true
    this.getUserRescheduledBookingDetails(this.user.data.phone);
    this.pageIndex = 0;
  }


  getUserRescheduledBookingDetails(bookingNO: string) {
    this.apiService.getBookingDetails(bookingNO).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.participantRescheduledBookingDetails = response.data;
          // Now that data is available, perform the filtering
        this.allRescheduledBookings = this.participantRescheduledBookingDetails.filter(
          (rescheduledBooking: { booking_completely_rescheduled: any }) => rescheduledBooking.booking_completely_rescheduled
        );
        this.length = this.allRescheduledBookings.length; 
        this.updateReschedulePagination();
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // this.storage.remove('token');
          this.spinner.hide();
        }
      },
      error: (err: any) => {
        this.snackBar.open(err.error.response.message, '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        // this.storage.remove('token');
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
       }
    });
  }


  cancelledBookings() {
    this.spinner.show();
    this.errors = "";
    this.bookingNo = "";
    this.isCancelled = true;
    this.isRescheduled = false;
    this.pageIndex = 0;

    this.getUserCancelledBookingDetails(this.user.data.phone);
  }

  getUserCancelledBookingDetails(bookingNO: string) {
    this.apiService.getBookingDetails(bookingNO).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.participantCancelledBookingDetails = response.data;         
          // Filter the bookings to get only the ones where isCancelled is true
          this.allCancelledBookings = this.participantCancelledBookingDetails.filter((cancelledBookings: { is_cancelled: any; }) => cancelledBookings.is_cancelled);
          this.length = this.allCancelledBookings.length; 
          this.updateCancelPagination();
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // this.storage.remove('token');
          this.spinner.hide();
        }
      },
      error: (err: any) => {
        this.snackBar.open(err.error.response.message, '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        // this.storage.remove('token');
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
       }
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.errors = ""; 
    this.bookingNo = "";
    this.user = this.authService.getUser();
    this.getUserBookingDetails(this.user.data.phone); 
  }

}
